import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ './views/login/login.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/my',     //我的页面
      name: 'my',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "my" */ './views/my/My.vue')
    },
    {
      path: '/category',    //分类页面
      name: 'category',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "category" */ './views/category/category.vue'),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/details',      //详情页面
      name: 'details',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "details" */ './views/category/details.vue'),
      meta: {
        keepAlive: false //
      }
    },
    {
      path: '/cash',      //现货页面
      name: 'cash',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cash" */ './views/cash/cash.vue'),
      meta: {
        keepAlive: true //
      }
    },
    {
      path: '/inventory',      //库存页面
      name: 'inventory',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "inventory" */ './views/my/inventory.vue')
    },
    {
      path: '/member',      //会员页面
      name: 'member',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "member" */ './views/my/member.vue')
    },
    {
      path: '/search',      //搜索页面
      name: 'search',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/search/search.vue'),
      meta: {
        keepAlive: true //
      }
    },
    {
      path: '/searchresult',      //搜索结果
      name: 'searchresult',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/search/searchresult.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/history',      //历史页面
      name: 'history',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/history/history.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/vip',      //会员页面
      name: 'vip',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/vip/vip.vue')
    },
    {
      path: '/activitydetail',      //活动详情
      name: 'activitydetail',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/activity/activityDetail.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/activitylist',      //活动列表
      name: 'activitylist',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/activity/activityList.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/video',      //活动列表
      name: 'video',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/video/video.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/videodetail',      //活动列表
      name: 'videodetail',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "search" */ './views/video/videoDetail.vue'),
      meta: {
        keepAlive: false // 需要被缓存
      }
    }
  ]
})
